import { OnwardLink, OnwardLinksUI } from "./OnwardLinksUI";
import { StandardProps } from "../componentMap";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { ParsedUrlQuery } from "querystring";
import { noticeError } from "../../utils/newrelic/requests";

export type OptiversalResponse = {
  title: string;
  url: string;
  pageType: string;
  imageUrl: string;
  dateAdded: string;
};

const OPTIVERSAL_ORG_ID = "d7fb5e6ec8be611ce6b";
const OPTIVERSAL_RELATED_API =
  "https://www.johnlewis.com/buy/api/links/related?";
const MAX_RESULTS = 4;
const OPTIVERSAL_QUERY_TYPE = "topic";

export function OnwardLinks({ product }: Pick<StandardProps, "product">) {
  const queryParams: ParsedUrlQuery = useRouter().query;
  const [onwardsLinks, setOnwardsLinks] = useState<OnwardLink[]>([]);
  const productTitle = product.title;

  // queryparams are for testing - don't implement this in the final component
  const linkingQuery =
    (queryParams["osku"] && product.defaultVariant.id) ||
    queryParams["oquery"] ||
    encodeURIComponent(productTitle.trim());

  const queryType = queryParams["oqueryType"] || OPTIVERSAL_QUERY_TYPE;

  const processResults = (resultJson: OptiversalResponse[]) => {
    setOnwardsLinks(
      resultJson.map((result) => {
        return {
          title: result.title,
          url: result.url,
          imageUrl: result.imageUrl,
        };
      }),
    );
  };

  const fetchResults = async () => {
    try {
      const options = {
        method: "GET",
        headers: { accept: "application/json" },
      };
      const res = await fetch(
        `${OPTIVERSAL_RELATED_API}o=${OPTIVERSAL_ORG_ID}&query=${linkingQuery}&queryType=${queryType}&max=${MAX_RESULTS}`,
        options,
      );
      const json = await res.json();
      json.results && processResults(json.results);
    } catch (e: any) {
      noticeError(`Optiversal API error: error ${e.message}`);
    }
  };

  useEffect(() => {
    fetchResults();
  }, []);

  const renderOnwardLinks = () => {
    const skeletonLink = {
      title: "",
      url: "",
    };
    const skeletonLinks = new Array(MAX_RESULTS).fill(skeletonLink);
    return onwardsLinks.length > 0 ? (
      <OnwardLinksUI onwardLinks={onwardsLinks} />
    ) : (
      <OnwardLinksUI onwardLinks={skeletonLinks} />
    );
  };

  return <div>{renderOnwardLinks()}</div>;
}
